export default "__VITE_ASSET__DtJyKzPx__"